import React, {Component} from 'react'
import SearchIcon from '../../assets/img/icon/search.svg' 
import CheckIcon_b from '../../assets/img/icon/check_blue.svg'
import CheckIcon_g from '../../assets/img/icon/check_gray.svg' 
import SearchItemTop from '../SearchItemTop' 
import ConfirmBtn from '../ConfirmBtn'

class NarualSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywordList : [],
            keyword:"",
            isOpen:props.data.condition==="editing" || props.data.condition==="editable",
            loading:true,
        };
    }

    componentWillUpdate(props,state) {
        if(!this.state.isOpen && (props.data.condition === "editing" || props.data.condition === "editable")) {
            this.setState({isOpen:true});
        } else if(this.state.isOpen && props.data.condition === "complete") {
            this.setState({isOpen:false});
        } else if (this.state.isOpen && props.data.condition === "waiting") {
            this.setState({selectedKeyword: props.data.keyword,isOpen: false,loading:true})
        } else if(this.state.keywordList !== props.data.keyword) {
            this.setState({keywordList : props.data.keyword})
        }
    }

    addKeyword(e) {

        if(e.key==="Enter" && this.state.keyword.trim()!=="") {
            let keywordList = this.state.keywordList;

            let isExist = keywordList.findIndex(keyword => keyword === this.state.keyword) !== -1;
    
            if(!isExist) {
                keywordList.push(this.state.keyword);
                this.setState({keywordList:keywordList, keyword:""})
            }
            this.setState({keyword:""});

            this.props.editItem(this.props.data, keywordList);
        } 

    }

    deleteKeyword(v) {

        let keywordList = this.state.keywordList;

        let idx = keywordList.findIndex(function(keyword) {return keyword === v}) 
        if (idx > -1) keywordList.splice(idx, 1);
         
        this.setState({keywordList:keywordList})
        this.props.editItem(this.props.data, keywordList);

    }

    confirm() {
        
        if(this.state.keywordList.length!==0) {
            // console.log(this.state.keywordList);
            this.props.addSearchKeyword(this.state.keywordList);
        }
    }

    render() { 

        let keywordList = this.state.keywordList;
        let data = this.props.data;
            
        return (
            <div id={data.id} className={data.condition==="waiting" ? 
                        "search-item-wrap natural-search movable" : "search-item-wrap natural-search"}>
                <SearchItemTop addLibrary={(type, id, code)=>this.props.addLibrary(type, id, code)}
                                data={this.props.data} isOpen={this.state.isOpen} keywordList={this.state.keywordList}
                                setIsOpen={(isOpen)=>this.setState({isOpen:isOpen})}
                                deleteItem={()=>this.props.deleteItem()}
                               libraryList = {this.props.libraryList}/>

                {(this.state.isOpen || data.condition==="editing") && 
                    <React.Fragment>
                        {keywordList.length!==0 && 
                            <ul className="keyword-list">
                                {keywordList.map((v,k)=>{
                                    return <li key={k} className="active"> 
                                            <span>{v}</span>
                                            {(data.condition==="editing" || data.condition==="editable") &&
                                                <button className="delete-keyword" 
                                                    onClick={()=>this.deleteKeyword(v)}>&times;</button>
                                            } 
                                            
                                        </li>
                                })}
                            </ul>
                        }
                        
                        {data.condition!=="complete" && 
                            <div className={this.state.focus ? "search-input-wrap active" : "search-input-wrap"}>
                                <img src={SearchIcon} onClick={(e)=>this.addKeyword({key:"Enter"})} className="pointer"/>
                                <input value={this.state.keyword} onChange={(e)=>this.setState({keyword:e.target.value})}
                                    placeholder="Please type and press enter" onKeyPress={(e)=>this.addKeyword(e)} 
                                    onFocus={()=>this.setState({focus:true})} onBlur={()=>this.setState({focus:false})}/> 
                            </div> 
                        } 

                        {(data.condition!=="complete" && data.condition!=="editable") && 
                            <ConfirmBtn isConfirm={this.props.beforeItem ? this.props.beforeItem.keyword.length!==0 && this.state.keywordList.length!==0 : this.state.keywordList.length!==0} 
                                        onClick={()=>this.confirm()}/>
                        }
                        
                    </React.Fragment>
                }

                

            </div>
        )
    }
}


export default NarualSearch; 

